import { SIGNER_ADD_FAILURE, SIGNER_ADD_REQUEST, SIGNER_ADD_RESET, SIGNER_ADD_SUCCESS,
SIGNER_DELETE_FAILURE, SIGNER_DELETE_REQUEST, SIGNER_DELETE_RESET, SIGNER_DELETE_SUCCESS,

 } from "../actions/signers";

const initialState = {
  state: "idle",
};


export function signerAdd(state = initialState, action) {
  switch (action.type) {
    case SIGNER_ADD_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case SIGNER_ADD_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case SIGNER_ADD_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case SIGNER_ADD_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}

export function signerDelete(state = initialState, action) {
  switch (action.type) {
    case SIGNER_DELETE_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case SIGNER_DELETE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case SIGNER_DELETE_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case SIGNER_DELETE_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
